import type { Path } from 'react-router';
import { parseProjectContextSearchParams } from '@gonfalon/app-context/parseProjectContextSearchParams';
import type { ProjectContext } from '@gonfalon/app-context/projectContext';
import { projectContextSearchParamsUpdater } from '@gonfalon/app-context/projectContextSearchParamsUpdater';
import { projectContextToURLSearchParams } from '@gonfalon/app-context/projectContextToURLSearchParams';

export function withNewProjectContext(projectContext: ProjectContext) {
  return (path: Path) => {
    const context = projectContextToURLSearchParams(projectContext);

    if (!context) {
      return path;
    }

    const searchParams = new URLSearchParams(path.search);

    const nextContext = parseProjectContextSearchParams(context);

    const nextSearchParams = projectContextSearchParamsUpdater(searchParams, nextContext);

    return {
      ...path,
      search: nextSearchParams.toString(),
    };
  };
}
